interface Props {
  title: string
  status: "inProgress" | "complete" | "executing" | string
  passed?: boolean
  errors?: string
}

export function VerificationCard({ title, status, passed, errors }: Props) {
  const isDone = status === "complete"

  return (
    <div
      className={`rounded-md border px-3 py-2 text-xs ${
        !isDone
          ? "border-gray-200 bg-gray-50"
          : passed
            ? "border-green-300 bg-green-50"
            : "border-red-300 bg-red-50"
      }`}
    >
      <div className="flex items-center gap-1.5">
        <span>{isDone ? (passed ? "✓" : "✗") : "⟳"}</span>
        <span className="font-medium">{title}</span>
      </div>
      {isDone && errors && !passed ? (
        <pre className="mt-1 whitespace-pre-wrap leading-relaxed text-red-700">{errors}</pre>
      ) : null}
    </div>
  )
}
